export default __webpack_public_path__ + "static/media/PublicSans-Regular.296b09a9.ttf";